import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { MatSnackBar } from '@angular/material';
import {AdoptionService} from '../../services/adoption.service';
@Component({
  selector: 'app-adoptionrequestdetail',
  templateUrl: './adoptionrequestdetail.component.html',
  styleUrls: ['./adoptionrequestdetail.component.css']
})
export class AdoptionrequestdetailComponent implements OnInit {
  action: any;
  msg: string;
  mymobile: any;
  myemail: any;
  state: any;
  city: any;
  request_id: any;
  user_id: any;
  user: any;
  adoptionform: any;
  request: any;
  loading = false;
  actiontype: any;
  contacttype: any;
  changeflag = 0;
  constructor(private commonService: CommonService, private adoptionService: AdoptionService,private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef <AdoptionrequestdetailComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any) {
      window.scrollTo(0, 0);
      this.user_id = this.data.uid;
      this.request_id = this.data.formid;
      const udata = this.commonService.getUserDataLocally();
      this.mymobile = udata.umobile;
      this.myemail = udata.uemail;
     }

  ngOnInit() {
    this.commonService.getParticularDummyUser(this.user_id)
    .subscribe(
      (x) => {
        this.user = x;
      });
      this.getrequestDetail();
      this.getAdoptionCity();
      this.getAllState();
  }
  getrequestDetail() {
    this.loading = true;
    this.adoptionService.getAdoptionrequestDetail(this.request_id)
    .subscribe(
      (x) => {
        this.request = x;
        this.loading = false;
        this.getAdoptionFormDetail(this.request.adoptionform_id)
      });
  }
  getAdoptionFormDetail(fid) {
    this.loading = true;
    this.adoptionService.getAdoptionFormDetail(fid)
    .subscribe (
      (x) => {
        this.adoptionform = x;
        this.loading = false;
      });
  }
  getAdoptionCity() {
    this.adoptionService.getAdoptionCity()
    .subscribe(
      (x) => {
        this.loading = false;
        this.city = x;
      }
    );
  }
  getAllState() {
    this.adoptionService.getAllState()
    .subscribe(
      (x) => {
        this.state = x;
    });
  }
  rejectForm() {
    this.loading = true;
    this.adoptionService.rejectForm(this.request.id)
    .subscribe(
      (x) => {
        this.request.status = 'rejected';
        this.changeflag = 1;
        this.msg = 'Request rejected';
        this.loading = false;
        this.openSnackBar();
        this.goBack();
      });
  }
  openSnackBar() {
    this.snackBar.open(this.msg , this.action, {
      duration: 4000,
    });
  }
  shortlistForm() {
    this.loading = true;
    this.adoptionService.shortlistForm(this.request.id, this.contacttype)
    .subscribe(
      (x) => {
        this.request.status = 'rejected';
        this.msg = 'Request Shortlisted';
        this.changeflag = 1;
        this.loading = false;
        this.openSnackBar();
        this.goBack();
      });
  }
  goBack() {
    let result = 0;
    if (this.changeflag == 1) {
      result = 1
    }
    this.dialogRef.close(result);
  }

}
